<template>
    <div>
        <b-row v-if="despesa">
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            DESPESA - <b-badge variant="warning">Detalhar</b-badge>
                        </span>
                    </b-card-header>

                    <b-card-body>
                        <despesa-detalhar
                            :despesa="despesa"
                            :servicos="servicos"
                            :mostrarTimeLine="exibirTimeline"
                            @obterAtualizacao="$emit('obterAtualizacao')"
                        >
                            <template slot="footer">
                                <slot name="footer"></slot>
                            </template>
                        </despesa-detalhar>
                    </b-card-body>

                    <b-card-footer>
                        <slot name="footer"></slot>
                        <btn-atualizar-despesa
                            v-if="mostrarBtnAtualizarDespesa"
                            :rotaAtualizarDespesa="rotaAtualizarDespesa"
                            :despesaId="despesa.despesaId"
                        ></btn-atualizar-despesa>
                        <btn-atualizar-despesa-compra
                            v-if="mostrarBtnAtualizarDespesaCompra"
                            :despesa="despesa"
                            :servicos="servicos"
                            @obterAtualizacao="$emit('obterAtualizacao')"
                        ></btn-atualizar-despesa-compra>
                        <historico
                            titulo='Histórico da Despesa'
                            tipo="B"
                            :servicos="servicos"
                            :id="despesa.despesaId"
                            class="ml-2"
                            v-if="temAcessoHistorico"
                        ></historico>
                        <b-button
                            variant="primary"
                            class="ml-2 mr-1"
                            @click.stop="mostrarTimeline()"
                        >
                            {{ textoBtnTimeline }} Timeline
                        </b-button>
                        <btn-devolver
                            :despesa="despesa"
                            :servicos="servicos"
                            :permiteAcessoPorPerfil="temAcessoAtualizarDespesa"
                            @obterDespesa="$emit('obterDespesa')"
                        ></btn-devolver>
                        <b-button
                            variant="primary"
                            class="ml-2"
                            @click.stop="$emit('mostrarAnexos')"
                            v-if="temAcessoAnexos && !mostrarAnexos"
                        >
                            <i class="fa fa-paperclip"></i> Anexos
                        </b-button>
                        <btn-cancelar
                            :despesa="despesa"
                            :servicos="servicos"
                            @obterDespesa="$emit('obterDespesa')"
                        ></btn-cancelar>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
        <despesa-anexos
            v-if="mostrarAnexos"
            :anexos="anexos"
            :temAcessoAtualizarAnexos="temAcessoAtualizarDespesa"
            :statusPermiteAtualizar="statusPermiteAtualizar"
            :servicos="anexoServicos"
            @fecharAnexos="$emit('fecharAnexos')"
            @atualizarAnexos="$emit('mostrarAnexos')"
            @inserirAnexo="$emit('inserirAnexo')"
            @excluirAnexo="$emit('excluirAnexo', $event)"
            @atualizarAnexo="$emit('atualizarAnexo', $event)"
            @baixarAnexo="$emit('baixarAnexo', $event)"
        >
        </despesa-anexos>
        <itens-despesas
            v-if="despesa"
            :temAcessoDetalharItem="temAcessoDetalharItem"
            :despesa="despesa"
            :itens="despesa.itensDespesas"
            :rotaDetalharItem="rotaDetalharItem"
            :rotaAtualizacaoEmMassa="rotaAtualizacaoEmMassa"
            :temAcessoInserirItem="temAcessoInserirItem"
            :temAcessoAtualizarItem="temAcessoAtualizarItem"
            :statusPermiteAtualizar="statusPermiteAtualizar"
            :statusPermiteManipularItem="statusPermiteManipularItem"
            @inserirItem="$emit('inserirItem')"
            @atualizarItem="$emit('atualizarItem', $event)"
            @excluirItem="$emit('excluirItem', $event)"
            @obterUnidades="$emit('obterUnidades')"
            @obterProjetos="$emit('obterProjetos', $event)"
            @obterAcoes="$emit('obterAcoes', $event)"
            :unidades="unidades"
            :projetos="projetos"
            :acoes="acoes"
            @salvarRateios="$emit('salvarRateios', $event)"
        >
            <template slot="itensAcoes" slot-scope="data">
                <slot name="itensAcoes" v-bind="data"></slot>
            </template>
        </itens-despesas>
    </div>
</template>

<script>
import DespesaDetalhar from './DespesaDetalhar.vue';
import ItensDespesas from '../itensDespesas/ItensDespesas.vue';
import BtnAtualizarDespesa from './BtnAtualizarDespesa.vue';
import BtnAtualizarDespesaCompra from './BtnAtualizarDespesaCompra.vue';
import DespesaAnexos from './DespesaAnexos.vue';
import BtnExcluirComprometimento from './BtnExcluirComprometimento.vue';
import { StatusDespesa } from './StatusDespesa';
import BtnDevolver from './BtnDevolver.vue';
import { StatusComprometimento } from './StatusComprometimento';
import BtnCancelar from './BtnCancelar.vue';
import Historico from '../../../../shared/components/Historico'

export default {
    props: {
        despesa: {
            type: Object,
        },    

        temAcessoDetalharItem: {
            type: Boolean,
            default: () => false
        },

        rotaDetalharItem: {
            type: String
        },

        rotaAtualizacaoEmMassa: {
            type: String
        },

        temAcessoInserirItem: {
            type: Boolean,
            default: () => false
        },

        temAcessoAtualizarItem: {
            type: Boolean,
            default: () => false
        },

        temAcessoAtualizarDespesa: {
            type: Boolean,
            default: () => false
        },

        rotaAtualizarDespesa: {
            type: String
        },

        mostrarAnexos: {
            type: Boolean,
            default: () => false
        },

        temAcessoAnexos: {
            type: Boolean,
            default: () => false
        },

        temAcessoHistorico: {
            type: Boolean,
            default: () => false
        },

        anexos: {
            type: Array,
            defualt: () => ([])
        },

        servicos: {
            type: Object,
            default: () => ({})
        },
        
        anexoServicos: {
            type: Object,
            default: () => ({})
        },

        unidades: {
            type: Array
        }, 

        projetos: {
            type: Array
        }, 
        
        acoes: {
            type: Array
        }
    },

    components: {
        DespesaDetalhar,
        ItensDespesas,
        BtnAtualizarDespesa,
        BtnAtualizarDespesaCompra,
        DespesaAnexos,
        BtnExcluirComprometimento,
        BtnDevolver,
        BtnCancelar,
        Historico
    },

    computed: {
        statusPermiteAtualizar() {
            return this.despesa != null
                && this.despesa.solicitanteDespesa
                && (
                    this.despesa.statusId == StatusDespesa.CRIADA
                        || this.despesa.statusId == StatusDespesa.REPROVADA_POR_DEMANDANTE
                        || this.despesa.statusId == StatusDespesa.REPROVADA_POR_GERENTE
                        || this.despesa.statusId == StatusDespesa.REPROVADA_PELA_UABS
                )
        },

        statusPermiteManipularItem() {
            return this.statusPermiteAtualizar 
                && ( this.despesa.statusComprometimentoId == StatusComprometimento.NAO_COMPROMETIDO 
                    || (this.despesa.statusComprometimentoId == StatusComprometimento.ERRO 
                        && this.despesa.idMov == null))
        },

        mostrarBtnAtualizarDespesa() {
            return this.temAcessoAtualizarDespesa 
                && this.statusPermiteAtualizar
        }, 

        mostrarBtnAtualizarDespesaCompra() {
            return this.temAcessoAtualizarDespesa 
                && this.statusPermiteAtualizar
                && this.despesa.movimentoCompra
                && this.$temAcessoView('DESP-GERAIS-REQ-07')
                && !this.despesa.possuiPagamento
        }
    },

    data() {
        return {
            textoBtnTimeline: 'Exibir',
            exibirTimeline: false
        }
    },

    created(){
        if (this.$route.name == 'DespesasGerais_Requisitantes_Despesas_Detalhar') {
            this.$emit('mostrarAnexos')
        }
    },

    methods: {
        mostrarTimeline() {
            this.exibirTimeline = !this.exibirTimeline
            if (!this.exibirTimeline) {
                this.textoBtnTimeline = 'Exibir'
            } else {
                this.textoBtnTimeline = 'Ocultar'
            }
        }
    }
}

</script>